<template>
  <div>
    <b-button
      :id="`${id_popover}`"
      size="sm"
      :variant="variant"
      @click="$bvModal.show(`${click_modal}`)"
      class="noprint"
    >
      <b-icon-info-circle-fill></b-icon-info-circle-fill>
    </b-button>
    <b-popover
      :target="`${id_popover}`"
      placement="top"
      variant="info"
      triggers="hover"
      boundary="viewport"
    >
      {{ popover_text }}
    </b-popover>
  </div>
</template>

<script>
// import * as names from "@/store/names";
// import { mapGetters } from "vuex";
export default {
  name: "ButtonErrorInstrument",
  components: {},
  props: {
    popover_text: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: "danger",
    },
    id_popover: {
      type: String,
      required: true,
    },
    click_modal: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    // ...mapGetters({}),
  },
  methods: {},
  created() {},
};
</script>

<style scoped>
.btn-error {
  padding: 1.2px !important;
  width: 23px !important;
  height: 23px !important;
  font-size: 10pt;
}
</style>

